import { WaveItem } from '../../../services/fulfillment/types';

export interface PickSegment {
  binCode: string;
  quantity: number;
}

export function derivePickSegments(item: WaveItem): PickSegment[] {
  const pickLocs = item.binLocations
    .filter(l => l.locationType === 'pick' || l.locationType === 'refurbished')
    .sort((a, b) => b.quantity - a.quantity);
  const segments: PickSegment[] = [];
  let remaining = item.quantity;
  for (const loc of pickLocs) {
    if (remaining <= 0) break;
    segments.push({ binCode: loc.binCode, quantity: Math.min(remaining, loc.quantity) });
    remaining -= loc.quantity;
  }
  return segments;
}
